



























































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import FilterTable from './Components/FilterTable.vue'
import FilterTablePowerUser from './Components/FilterTablePowerUser.vue'
import TableMenu from './Components/TableMenu.vue'
import TableMenuPowerUser from './Components/TableMenuPowerUser.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { UserModule } from '@/app/store/modules/user'
import { AuthModule } from '@/app/store/modules/auth'

@Component({
  name: 'User',
  components: {
    'top-menu': TopMenu,
    'filter-table': FilterTable,
    'filter-table-power-user': FilterTablePowerUser,
    'table-menu': TableMenu,
    'table-menu-power-user': TableMenuPowerUser,
    pagination: Pagination,
  },
})
export default class extends Vue {
  private selected = []

  public created() {
    UserModule.paginationParam.search = ''
    UserModule.paginationParam.filter.position = ''
    UserModule.paginationParam.filter.dealername = ''
    UserModule.paginationParam.filter.dealerCity = ''
    UserModule.paginationParam.filter.dealerBranch = ''
    UserModule.paginationParam.filter.active = ''
    UserModule.paginationParam.filter.dealerarea = ''
    UserModule.paginationParam.filter.team = ''
    UserModule.paginationParam.filter.dealercode = ''
    UserModule.paginationParam.filter.dealergroup = ''
    UserModule.paginationParam.filter.statusRegistration = ''
    UserModule.paginationParam.filter.type = 'dnet'
    UserModule.paginationParamsExport.filter.type = 'dnet'
    if (this.storageType === 'sfid') {
      this.getUserSFD()
    } else {
      this.getUserDNET()
    }
    this.getExport()
  }

  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }

  public get linkExport() {
    return UserModule.exportData.data
  }
  public get getUserDataDnet() {
    return UserModule.userDataDNET
  }
  public get getUserDataSFD() {
    return UserModule.userDataSFD
  }

  public getExport() {
    UserModule.getExportData()
  }
  public getUserDNET() {
    UserModule.getUserDataDNET()
  }
  public getUserSFD() {
    UserModule.getUserDataSFID()
  }
  public get isLoadingExport() {
    return UserModule.isLoadingExport
  }
  public get isLoading() {
    return UserModule.isLoading
  }
  public get storageType() {
    return UserModule.paginationParam.filter.type
  }
  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    UserModule.paginationParam.paging.page = 1
    UserModule.paginationParam.paging.limit = 10
    UserModule.paginationParam.sort.column = 'id'
    UserModule.paginationParam.sort.type = 'asc'
    UserModule.paginationParam.search = item
    UserModule.paginationParamsExport.search = item
    if (this.storageType === 'sfid') {
      this.getUserSFD()
    } else {
      this.getUserDNET()
    }
    this.getExport()
  }

  private onPageNumChanged(limit: any) {
    UserModule.paginationParam.paging.limit = limit
    if (this.storageType === 'sfid') {
      this.getUserSFD()
    } else {
      this.getUserDNET()
    }
  }

  private funcFirstPage() {
    UserModule.paginationParam.paging.page = 1
    if (this.storageType === 'sfid') {
      this.getUserSFD()
    } else {
      this.getUserDNET()
    }
  }

  private funcPrevPage() {
    UserModule.paginationParam.paging.page =
      UserModule.paginationParam.paging.page - 1
    if (this.storageType === 'sfid') {
      this.getUserSFD()
    } else {
      this.getUserDNET()
    }
  }
  private funcNextPage() {
    UserModule.paginationParam.paging.page =
      UserModule.paginationParam.paging.page + 1
    if (this.storageType === 'sfid') {
      this.getUserSFD()
    } else {
      this.getUserDNET()
    }
  }

  private funcLastPage() {
    if (this.storageType === 'sfid') {
      UserModule.paginationParam.paging.page =
        (this.getUserDataSFD.pagination &&
          this.getUserDataSFD.pagination.pageCount) ||
        0
      this.getUserSFD()
    } else {
      UserModule.paginationParam.paging.page =
        (this.getUserDataDnet.pagination &&
          this.getUserDataDnet.pagination.pageCount) ||
        0
      this.getUserDNET()
    }
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
  public fieldsDNET: any = [
    { key: 'selected', sortable: false },
    { key: 'code', sortable: false },
    { key: 'name', sortable: false },
    { key: 'categoryName', sortable: false },
    { key: 'position', sortable: false },
    { key: 'dealerCode', sortable: false },
    { key: 'dealerName', sortable: false },
    { key: 'dealerCity', sortable: false },
    { key: 'dealerArea', sortable: false },
    { key: 'dealerGroup', sortable: false },
    { key: 'statusEmployee', sortable: false },
    { key: 'statusRegister', sortable: false },
    { key: 'photo', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public fieldsDNETPowerUser: any = [
    { key: 'selected', sortable: false },
    { key: 'code', sortable: false },
    { key: 'name', sortable: false },
    { key: 'categoryName', sortable: false },
    { key: 'position', sortable: false },
    { key: 'dealerCode', sortable: false },
    { key: 'dealerName', sortable: false },
    { key: 'dealerCity', sortable: false },
    { key: 'dealerArea', sortable: false },
    { key: 'dealerGroup', sortable: false },
    { key: 'statusEmployee', sortable: false },
    { key: 'statusRegister', sortable: false },
    { key: 'photo', sortable: false },
    { key: 'lastAccess', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public fieldsSFD: any = [
    { key: 'selected', sortable: false },
    { key: 'code', sortable: false },
    { key: 'name', sortable: false },
    { key: 'position', sortable: false },
    { key: 'dealerGroup', sortable: false },
    { key: 'statusEmployee', sortable: false },
    { key: 'statusRegister', sortable: false },
    { key: 'photo', sortable: false },
    { key: 'actions', sortable: false },
  ]
}
